// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"146":"acf9bdfc","230":"acf9bdfc","644":"acf9bdfc","955":"fb2c5b54","996":"393d1dc4"}[chunkId] + ".chunk.css";
};